import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import ICreditLineDetails from '@sunbit-dev/common/models/cardApply/ICreditLineDetails';
import IApplicationError from '@sunbit-dev/common/models/IApplicationError';
import { Actions } from '../actions/identificationActions';
import { ActionTypes } from '../models/actions/identification';

export interface ICreditLineDetailsState extends ICreditLineDetails {
  type?: ActionTypes;
  status?: ActionStatus;
  error?: IApplicationError;
}

const initialState: ICreditLineDetailsState = {
  pricingDisplayName: '',
  creditLine: 0,
  apr: 0,
  primeRate: 0,
  offerDate: '',
};

export default function creditLineReducer(state = initialState, action: Actions): ICreditLineDetailsState {
  switch (action.type) {
    case ActionTypes.ApplyForCreditLine:
      return { ...state, ...action };
    default:
      return state;
  }
}
